import { render, staticRenderFns } from "./turntable-coupon.vue?vue&type=template&id=6cbc634f&scoped=true&"
import script from "./turntable-coupon.vue?vue&type=script&lang=js&"
export * from "./turntable-coupon.vue?vue&type=script&lang=js&"
import style0 from "./turntable-coupon.vue?vue&type=style&index=0&id=6cbc634f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc634f",
  null
  
)

export default component.exports